const colors = {
  blue: ["#2015ff"],
  gray: ["#222222", "#333333", "#555555", "#777777", "#dddddd", "#f4f4f4"],
};

export default colors;
